import React from "react";

const MapsComponent: React.FC = () => {
  return (
    <div style={{ padding: "0 20px" }}> {/* <-- Horizontal padding */}
      <h2
        style={{
          textAlign: "center",
          paddingTop: "30px",
          paddingBottom: "20px",
          marginBottom: "30px",
          color:"#5e626b"
        }}
      >
        OUR LOCATION
      </h2>
      <div className="contactMap">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15906645.364323009!2d78.1615065!3d13.2592733!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba85bed4aca70ed%3A0xfba5d5132ba65a55!2sGanga%20Super%20Market!5e0!3m2!1sen!2sin!4v1743665927394!5m2!1sen!2sin"
          width="100%"
          height="400px"
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="ganga-supermarket-map"
          style={{ border: 0, borderRadius: "8px" }} // optional rounded corners
        ></iframe>
      </div>
    </div>
  );
};

export default MapsComponent;
